import { Fragment } from "react"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/20/solid"
import clsx from "clsx"
import Button from "@/components/Button"
import downloadPgn from "@/utils/downloadPgn"
import { Modals, useModals } from "@/hooks/useModals"
import axios from "axios"
import { Game } from "@/types/serializers"

const ImportExportGamesDropdown = () => {
  const { openModal } = useModals()

  const handleExport = async () => {
    try {
      const { data } = await axios.get<Game[]>("/api/games")

      downloadPgn(data, "All games")
    } catch (error) {
      console.error(error)
      alert("Export failed.")
    }
  }

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton as={Fragment}>
          <Button size="sm" style="secondary">
            <span className="sr-only">Options</span>
            <ChevronDownIcon
              className="ui-open:rotate-180 h-5 w-5 transition-transform duration-100 ease-out"
              aria-hidden="true"
            />
          </Button>
        </MenuButton>
      </div>

      <MenuItems
        transition
        className={clsx([
          "absolute left-0 z-10 mt-2 w-36 origin-top-left overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none sm:right-0 sm:origin-top-right",
          "data-closed:scale-95 data-closed:opacity-0",
          "data-enter:duration-100 data-enter:ease-out",
          "data-leave:duration-75 data-leave:ease-in",
        ])}
      >
        <div className="py-2">
          <MenuItem>
            <button
              onClick={handleExport}
              className="block w-full px-4 py-3 text-left text-sm text-gray-700 disabled:opacity-30 data-focus:bg-gray-100 data-focus:text-gray-900"
            >
              Export all as PGN
            </button>
          </MenuItem>
          <MenuItem>
            <button
              onClick={() => openModal(Modals.ImportGames)}
              className="block w-full px-4 py-3 text-left text-sm text-gray-700 disabled:opacity-30 data-focus:bg-gray-100 data-focus:text-gray-900"
            >
              Import games
            </button>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  )
}

export default ImportExportGamesDropdown
